// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3CPwF","validationTips":"StatementDescriptor_validationTips__2I6EF"};